<template>
  <div class="allow-content__container black--text">
    <div class="allow-content__icon-container">
      <img
        src="~/static/images/Warning.svg"
        alt="Warning Icon"
        class="allow-content__icon"
      />
    </div>
    <div class="allow-content__text-content body-1">
      <div class="allow-content__title">Allow content?</div>
      <div>
        This content requires functional cookies. To view content please
        <button class="allow-content__link" @click="updateCookiePreferences">
          update your cookie preferences.
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllowContent",
  methods: {
    updateCookiePreferences() {
      if (window?.OneTrust?.ToggleInfoDisplay) {
        window.OneTrust.ToggleInfoDisplay();
      }
    },
  },
};
</script>

<style scoped>
.allow-content__container {
  display: flex;
  gap: 1.15rem;
  align-items: flex-start;
  padding: 1.15rem;
  border: solid 1px black;
  border-radius: 8px;
  background-color: #e8e8e8;
}

.allow-content__icon {
  height: 1.75rem;
  width: 1.75rem;
}

.allow-content__text-content {
  display: flex;

  flex-direction: column;
  gap: 1.15rem;
  align-items: flex-start;
}

.allow-content__title {
  font-weight: 700;
}

button.allow-content__link {
  font-weight: 700;
  color: #000000;
  text-decoration: underline;

  &:hover {
    color: #2b3ede;
  }

  &:focus,
  &:focus-visible,
  &:active {
    color: #071cca;
  }

  &:focus-visible {
    outline: 1px solid #071cca;
    outline-offset: 2px;
    background-color: #e5e7ff;
  }
}
</style>
